import {createStyles, makeStyles, Theme} from "@material-ui/core";


export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        draftContractPage: {
            paddingTop: 60,
            paddingBlock: 60,
            fontSize: 16,
        },
        draftContractPageTitle: {
            textAlign: 'center',
            marginBottom: 30,
        },
        draftContractPageSubTitle: {
            maxWidth: 450,
            display: 'flex',
            alignItems: 'center',
            gap: 15,
            [theme.breakpoints.down('xs')]: {
                maxWidth: "100%",
            }
        },
        divider: {
            marginTop: 20,
            marginBottom: 20,
        },
        draftContractPageSubText: {
            fontSize: 14,
            maxWidth: 450,
            [theme.breakpoints.down('xs')]: {
                maxWidth: "100%",
                fontSize: 12
            }
        },
        radioButtons: {
            justifyContent: 'flex-start',
        },
        submitSection: {
            marginTop: 20,
            textAlign: 'center',
            gap: 10,
            display: 'flex',
            width: '100%',
        },
        draftContractSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: 25,
            marginBottom: 25,
        },
        formGroup: {
            display: 'flex',
            flexDirection: 'row',
            gap: 40
        },
        formBox: {
            display: 'flex',
            flexDirection: 'column',
            width: 450,
        },
        formLargeBox: {
            display: 'flex',
            flexDirection: 'column',
            width: 940,
        },
        formControl: {
            maxWidth: 450,
            width: '100%',
            marginTop: 0,
            minWidth: 450,
            [theme.breakpoints.down('xs')]: {
                maxWidth: "100%",
                fontSize: 12
            }
        },
        formControlComment: {
            // Per-field admin comment inputs are hidden together with the retired
            // "request changes" flow; remove display:none to bring them back
            display: 'none',
            maxWidth: 450,
            width: '100%',
            marginTop: 0,
            [theme.breakpoints.down('xs')]: {
                maxWidth: "100%",
                fontSize: 12
            }
        },
        formControlLabel: {
            [theme.breakpoints.down('xs')]: {
                fontSize: 14,
                maxWidth:' 90%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }
        },
        selectLabel: {
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: 12,
        },
        textarea: {
            width: 100 + "%",
            marginTop: 10,
            marginBottom: 20,
            minHeight: 50,
            borderRadius: 10,
            resize: 'none'
        },
        alert: {
            maxWidth: 450,
            color: "#B03534",
            fontSize: 16,
            boxSizing: 'border-box',
            [theme.breakpoints.down('xs')]: {
                maxWidth: "100%",
                fontSize: 12
            }
        },
        modalWindow: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            padding: 20,
            backgroundColor: theme.palette.background.paper,
            maxHeight: 600,
            overflow: 'auto',
            [theme.breakpoints.down('xs')]: {
                width: 250,
                padding: 20
            }
        },
        adminNotes: {
            padding: 7,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 10,
            position: 'relative',
            paddingLeft: 45,
            border: '1px solid #EF574E',
            borderRadius: 4,
            flex: 1,
            minHeight: 24,
            alignSelf: 'flex-start'
        },
        adminNotesLarge: {
            padding: 7,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 10,
            position: 'relative',
            paddingLeft: 45,
            border: '1px solid #EF574E',
            borderRadius: 4,
            flex: 1,
            minHeight: 97,
            alignSelf: 'flex-start'
        },
        adminNotesIcon: {
            fill: '#EF574E',
            position: 'absolute',
            left: 10,
            top: 6,
        },
        accordion: {
            marginBottom: '30px !important',
        }
    }),
);
